/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

export function getPasswordResetLink () {
  return '/password/reset'
}

export function getPasswordResetSuccessLink () {
  return '/password/reset/success'
}

export function getPasswordUpdateLink (params?: Record<string, unknown>) {
  return `/password/update?${stringify(params)}`
}
